import React, { createContext, useCallback, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';
import { makeUID } from '../helpers';

const ToastContext = createContext();

export default ToastContext;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback(
    (message, bg, props = {}) => {
      setToasts((prevToasts) => [...prevToasts, { message, bg, hash: makeUID(5), props }]);
    },
    [setToasts],
  );

  const removeToast = useCallback(
    (hash) => {
      setToasts((prevToasts) => prevToasts.filter((t) => t.hash !== hash));
    },
    [setToasts],
  );

  const getToastRemoveFunction = (hash) => () => removeToast(hash);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <ToastContainer position="top-end" style={{ zIndex: 1500 }} className="position-fixed">
        {toasts.map((toast) => (
          <Toast
            style={{ color: 'white' }}
            key={toast.hash}
            bg={toast.bg}
            onClose={getToastRemoveFunction(toast.hash)}
            delay={5000}
            autohide
            {...toast.props}
          >
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
}
